export const initialState = {
  ingredientsList: [],
  isLoading: false,
  error: null,
};
